import Cookies from "js-cookie";
import config from "../../config";

const tokenCookieKey = "sso-jwt-tkn";

export const getJwtToken = async () => {
    let token = Cookies.get(tokenCookieKey);

    if (!token) {
        token = await refreshJwtToken();
    }

    return token;
};

export const refreshJwtToken = async () => {
    const newToken = await fetch("/rest/oauth/tokens/refresh/v4")
        .then(response => response.json())
        .then(data => data.jwt)
        .catch(() => undefined);

    if (!newToken) {
        window.location.replace(`${config.LOGOUT_PAGE}`);

        return undefined;
    }

    Cookies.set(tokenCookieKey, newToken, {
        domain: `.${config.AUTH_COOKIES_DOMAIN}`,
        path: "/",
    });

    return newToken;
};
